import { Subscription } from "@/types/type";
import React from "react";
import { StyleSheet, Text, View } from "react-native";
import BuskerCard from "./BuskerCard";
import PlaceCard from "./PlaceCard";

const SubscriptionCard = ({
  subscription,
  styling,
}: {
  subscription: Subscription;
  styling?: string;
}) => {
  return (
    <View
      className={`bg-white p-4 rounded-lg shadow-none w-full items-center ${styling} m-1`}
    >
      {subscription.place && (
        <View className="w-full">
          <Text className="text-xs">
            Place Last activity: {subscription.last_activity}
          </Text>
          <PlaceCard
            place={subscription.place}
            style="bg-white p-3 rounded-2xl w-full items-center"
          />
        </View>
      )}

      {subscription.busker && (
        <View className="w-full">
          <Text className="text-xs">
            Busker Last activity: {subscription.last_activity}
          </Text>
          <BuskerCard busker={subscription.busker} />
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    justifyContent: "center",
  },
  image: {
    flex: 1,
    width: "100%",
    fontSize: 100,
    alignItems: "center",
    justifyContent: "center",
  },
});
export default SubscriptionCard;
